import { type Account } from './account';

export class UserProfile {
  public Accounts: Account[] = [];
  public TotalNumAccounts: number = 0;
  public IsPayPlan?: boolean;
  public FirstName?: string;
  public LastName?: string;
  public Email?: string;
  public UserName?: string;
  public UserId: string = '';
  public AuthToken?: string;
  public AuthTokenExpiration?: Date;
}
